import React, { createRef, useEffect, useRef, useState } from "react"
import Webform from "gatsby-drupal-webform"

import WebformFieldEmail from "./Webform/WebformFieldEmail"
import WebformFieldText from "./Webform/WebformFieldText"
import WebformFieldTextarea from "./Webform/WebformFieldTextarea"
import WebformActions from "./Webform/WebformActions"

const Form = ({ webform, ...props }) => {
  const [disabled, setDisabled] = useState(false)
  const [formKey, setFormKey] = useState(new Date().getTime())
  const actionRef = useRef(null)

  const onSuccess = response => {
    if (response.settings) {
      window.flash(response.settings.confirmation_message, "success")

      setDisabled(false)
      setFormKey(new Date().getTime())
    }
  }

  const onValidate = event => {
    setDisabled(true)

    event.preventDefault()
    let isValid = event.currentTarget.checkValidity()

    if (!isValid) {
      setDisabled(false)

      window.flash(
        "Au moins un champ de ce formulaire n'est pas conforme. Merci de contrôler votre saisie.",
        "danger"
      )
    }

    return isValid
  }

  useEffect(() => {
    if (actionRef.current) {
      if (disabled) {
        actionRef.current.setAttribute("disabled", disabled)
      } else {
        actionRef.current.removeAttribute("disabled")
      }
    }
  }, [disabled])

  return (
    <div key={formKey}>
      <Webform
        webform={webform}
        customComponents={{
          textfield: WebformFieldText,
          email: WebformFieldEmail,
          textarea: WebformFieldTextarea,
        }}
        buttonComponent={() => (
          <WebformActions
            ref={actionRef}
            disabled={disabled}
            disabledCallback={setDisabled}
          />
        )}
        endpoint={`${process.env.API_URL}${process.env.WEBFORM_ENDPOINT}`}
        onSuccess={onSuccess}
        onValidate={onValidate}
        noValidate={true}
        {...props}
      />
    </div>
  )
}

export default Form
